<template>
  <span v-if="value === '4' || value === '5'">
    <v-icon
      v-for="i in parseInt(value)"
      :key="`star-${i}`"
      :color="color"
      :icon="mdiStar"
      :size="size"
    />
  </span>
</template>

<script setup lang="ts">
import { mdiStar } from '@mdi/js'

defineProps({
  color: {
    default: 'yellow-darken-2',
    type: String
  },
  size: {
    default: 30,
    type: Number
  },
  value: {
    default: '',
    type: String
  }
})
</script>
